export const environment = {
    production: false,
    baseUrl: "https://esg.demo.bdomobile.com",
    apiUrl: "https://server.demo.bdomobile.com/",
    keycloakUrl: "https://keycloak-dev.mobiletract.com",
    realm: "bdo-demo",
    clientId: "esg-calculator-web",
    googleTagManagerId: 'GTM-XXXXXX',
    googleTagManagerPreview: 'env-3',
    googleTagManagerAuth: 'nwRCCNlB1-SPt0eiDeFIOw'
  };
